// src/components/client/allClaims/tds/StatusCell.js
import React from "react";
import ClaimStatusBadge from "../ClaimStatusBadge";

const StatusCell = ({ claim }) => {
  return (
    <td>
      <ClaimStatusBadge status={claim.status} />
    </td>
  );
};

export default StatusCell;
